import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=2bbe9bfe&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&id=2bbe9bfe&scoped=true&lang=css&"
import style1 from "./Record.vue?vue&type=style&index=1&id=2bbe9bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe9bfe",
  null
  
)

export default component.exports